import selectors from './selectors'
import * as actions from './actions'
import { AppState, Dispatch } from '../../../../types';
import { connect } from 'react-redux';
import { CloudHubSettingsPage, ValueProps, EventProps } from './CloudHubSettingsPage';
import { selectors as authSelectors } from '../../../../lifecycle/auth';
import { SettingsApplication } from '../common/model'

const mapProps = (state: AppState): ValueProps => ({
  organizationId: authSelectors.getOrganizationId(state),
  selectedEnvironment: selectors.selectedEnvironment(state),
  isTitanium: authSelectors.isMonitoringCenterPremium(state),
  environments: selectors.environments(state),
  environmentsLoading: selectors.isLoadingEnvironments(state),
  isLoadingCHSettings: selectors.isLoadingCHSettings(state),
  isChangingCHSettings: selectors.isChangingCHSettings(state),
  isNewAppsAgentEnabled: selectors.isNewAppsAgentEnabled(state),
  isLoadingResources: selectors.isLoadingResources(state),
  filteredResources: selectors.filteredResources(state),
  applyStatus: selectors.applyStatus(state),
  applyEnableMonitoringStatus: selectors.applyEnableMonitoringStatus(state),
  query: selectors.query(state)
});

const mapDispatch = (dispatch: Dispatch): EventProps => ({
  fetchEnvironments: () => dispatch(actions.fetchEnvironments()),
  selectEnvironment: (envId: string) => dispatch(actions.environmentSelected(envId)),
  fetchResources: (envId: string, changedEnvironment: boolean) => dispatch(actions.fetchResources(envId, changedEnvironment)),
  filterResources: (input: string) => dispatch(actions.filterResources(input)),
  checkedMonitoring: (id: string) => dispatch(actions.checkedMonitoring(id)),
  applyMonitoringChanges: (amEnabled: boolean, app: SettingsApplication) => dispatch(actions.setAMEnabled(amEnabled, app)),
  fetchCloudHubSettings: (enable: boolean) => dispatch(actions.fetchCloudHubSettings(enable)),
  postCloudHubSettings: (enable: boolean) => dispatch(actions.postCloudHubSettings(enable))
});

export default connect(mapProps, mapDispatch)(CloudHubSettingsPage)
